import {
  dateTimeCol,
  intCol,
  numCol,
  strCol,
} from '@integec/grid-tools/lib/cols'
import {
  modifiedDateCol,
  modifierCol,
  unitHeader,
  utilityReqHeader,
} from '../core/HeaderColTypeProps'

const Card97Headers = [
  unitHeader,
  intCol({ ident: 'year', display: 'Year', isKey: true, width: 50 }),
  intCol({
    ident: 'eventNum',
    display: 'Event Number',
    isKey: true,
    width: 60,
  }),
  intCol({ ident: 'eventIdx', display: 'Event Index', isKey: true, width: 60 }),
  strCol({
    ident: 'eventType',
    display: 'Event Type',
    isKey: true,
    isFiltered: true,
    width: 60,
  }),
  utilityReqHeader,
  dateTimeCol({
    ident: 'eventStart',
    display: 'Event Start Date',
    width: 150,
    displayFormat: 'MM/DD/YYYY HH:mm',
  }),
  dateTimeCol({
    ident: 'eventEnd',
    display: 'Event End Date',
    width: 150,
    displayFormat: 'MM/DD/YYYY HH:mm',
  }),
  strCol({ ident: 'availCap', display: 'Available Capacity' }),
  intCol({ ident: 'causeCode', display: 'Cause Code', isFiltered: true }),
  strCol({
    ident: 'conCode',
    display: 'Contribution Code',
    width: 200,
    alignment: 'left',
    ellipsis: true,
  }),
  strCol({ ident: 'ioCode', display: 'Dominant' }),
  dateTimeCol({
    ident: 'workStart',
    display: 'Work Start Date',
    width: 150,
    displayFormat: 'MM/DD/YYYY HH:mm',
  }),
  dateTimeCol({
    ident: 'workEnd',
    display: 'Work End Date',
    width: 150,
    displayFormat: 'MM/DD/YYYY HH:mm',
  }),
  intCol({ ident: 'manHour', display: 'Man Hours' }),
  strCol({ ident: 'failCode', display: 'Fail Code', isFiltered: true }),
  strCol({ ident: 'ampCode', display: 'Amplification Code', isFiltered: true }),
  strCol({
    ident: 'description',
    display: 'Description',
    width: 2000,
    alignment: 'left',
  }),

  modifierCol,
  modifiedDateCol,
  strCol({ ident: 'lock', display: 'Lock' }),
].map(e => ({ ...e, isFiltered: true, sortOrder: 'asc' }))

export default Card97Headers

export const CPSHeaders = [
  unitHeader,
  intCol({ ident: 'year', display: 'Year', isKey: true, width: 50 }),
  // intCol({ ident: 'eventIdx', display: 'Event Index', isKey: true, width: 60 }),
  // utilityReqHeader,
  dateTimeCol({
    ident: 'eventStart',
    display: 'Event Start',
    width: 150,
    displayFormat: 'MM/DD/YYYY HH:mm',
  }),
  dateTimeCol({
    ident: 'eventEnd',
    display: 'Event End',
    width: 150,
    displayFormat: 'MM/DD/YYYY HH:mm',
  }),
  numCol({
    ident: 'line',
    display: 'Duration',
  }),
  strCol({ ident: 'availCap', display: 'Available Cap' }),
  intCol({
    ident: 'eventNum',
    display: 'Event Number',
    isKey: true,
    width: 60,
  }),

  strCol({
    ident: 'description',
    display: 'Description',
    width: 2000,
    alignment: 'left',
  }),
  strCol({
    ident: 'eventType',
    display: 'Event Type',
    isKey: true,
    isFiltered: true,
    width: 60,
  }),
  intCol({ ident: 'causeCode', display: 'Cause Code', isFiltered: true }),
  strCol({ ident: 'ampCode', display: 'Amplification Code', isFiltered: true }),
  strCol({
    ident: 'string7',
    display: 'Misc. Operations',
    dataGetter: ({ rowData }) =>
      rowData && rowData.extension ? rowData.extension.string7 : undefined,
  }),
  // strCol({ ident: 'conCode', display: 'Contribution Code' }),
  strCol({ ident: 'ioCode', display: 'Dominant' }),
  // dateTimeCol({
  //   ident: 'workStart',
  //   display: 'Work Start Date',
  //   width: 150,
  //   displayFormat: 'MM/DD/YYYY HH:mm',
  // }),
  // dateTimeCol({
  //   ident: 'workEnd',
  //   display: 'Work End Date',
  //   width: 150,
  //   displayFormat: 'MM/DD/YYYY HH:mm',
  // }),
  // intCol({ ident: 'manHour', display: 'Man Hours' }),
  // strCol({ ident: 'failCode', display: 'Fail Code', isFiltered: true }),

  //   modifierCol,
  // modifiedDateCol,
  // strCol({ ident: 'lock', display: 'Lock' }),
].map(e => ({ ...e, isFiltered: true, sortOrder: 'asc' }))

export const APSCard97Headers = [
  unitHeader,
  intCol({ ident: 'year', display: 'Year', isKey: true, width: 50 }),
  intCol({
    ident: 'eventNum',
    display: 'Event Number',
    isKey: true,
    width: 60,
  }),
  intCol({ ident: 'eventIdx', display: 'Event Index', isKey: true, width: 60 }),
  strCol({
    ident: 'eventType',
    display: 'Event Type',
    isKey: true,
    isFiltered: true,
    width: 60,
  }),
  utilityReqHeader,
  dateTimeCol({
    ident: 'eventStart',
    display: 'Event Start Date',
    width: 150,
    displayFormat: 'MM/DD/YYYY HH:mm',
  }),
  dateTimeCol({
    ident: 'eventEnd',
    display: 'Event End Date',
    width: 150,
    displayFormat: 'MM/DD/YYYY HH:mm',
  }),
  strCol({ ident: 'availCap', display: 'Available Capacity' }),
  intCol({ ident: 'causeCode', display: 'Cause Code', isFiltered: true }),
  strCol({
    ident: 'conCode',
    display: 'Contribution Code',
    width: 200,
    alignment: 'left',
    ellipsis: true,
  }),
  strCol({ ident: 'ioCode', display: 'Dominant' }),
  dateTimeCol({
    ident: 'workStart',
    display: 'Work Start Date',
    width: 150,
    displayFormat: 'MM/DD/YYYY HH:mm',
  }),
  dateTimeCol({
    ident: 'workEnd',
    display: 'Work End Date',
    width: 150,
    displayFormat: 'MM/DD/YYYY HH:mm',
  }),
  intCol({ ident: 'manHour', display: 'Man Hours' }),
  strCol({ ident: 'failCode', display: 'Fail Code', isFiltered: true }),
  strCol({ ident: 'ampCode', display: 'Amplification Code', isFiltered: true }),
  numCol({ ident: 'eqHours', display: 'Eq. Hrs' }),
  numCol({ ident: 'eqMW', display: 'Eq. MWH' }),
  strCol({
    ident: 'description',
    display: 'Description',
    width: 2000,
    alignment: 'left',
  }),

  modifierCol,
  modifiedDateCol,
  strCol({ ident: 'lock', display: 'Lock' }),
].map(e => ({ ...e, isFiltered: true, sortOrder: 'asc' }))

export const DukeFossileCard97Headers = [
  utilityReqHeader,
  unitHeader,
  intCol({ ident: 'year', display: 'Year', isKey: true, width: 50 }),
  dateTimeCol({
    ident: 'eventStart',
    display: 'Event Start Date',
    width: 150,
    displayFormat: 'MM/DD/YYYY HH:mm',
  }),
  dateTimeCol({
    ident: 'eventEnd',
    display: 'Event End Date',
    width: 150,
    displayFormat: 'MM/DD/YYYY HH:mm',
  }),
  numCol({
    ident: 'line',
    display: 'Duration',
  }),
  numCol({ ident: 'eqHours', display: 'Eq. Hrs' }),
  // numCol({ ident: 'eqMW', display: 'Eq. MWH' }),
  intCol({
    ident: 'eventNum',
    display: 'Event Number',
    isKey: true,
    width: 60,
  }),
  intCol({ ident: 'eventIdx', display: 'Event Index', isKey: true, width: 60 }),
  strCol({
    ident: 'eventType',
    display: 'Event Type',
    isKey: true,
    isFiltered: true,
    width: 60,
  }),

  strCol({ ident: 'availCap', display: 'Available Capacity' }),
  intCol({ ident: 'causeCode', display: 'Cause Code', isFiltered: true }),
  strCol({
    ident: 'conCode',
    display: 'Contribution Code',
    width: 200,
    alignment: 'left',
    ellipsis: true,
  }),
  strCol({ ident: 'ioCode', display: 'Dominant' }),
  dateTimeCol({
    ident: 'workStart',
    display: 'Work Start Date',
    width: 150,
    displayFormat: 'MM/DD/YYYY HH:mm',
  }),
  dateTimeCol({
    ident: 'workEnd',
    display: 'Work End Date',
    width: 150,
    displayFormat: 'MM/DD/YYYY HH:mm',
  }),
  intCol({ ident: 'manHour', display: 'Man Hours' }),
  strCol({ ident: 'failCode', display: 'Fail Code', isFiltered: true }),
  strCol({ ident: 'ampCode', display: 'Amplification Code', isFiltered: true }),
  strCol({
    ident: 'description',
    display: 'Description',
    width: 2000,
    alignment: 'left',
  }),

  modifierCol,
  modifiedDateCol,
  strCol({ ident: 'lock', display: 'Lock' }),
].map(e => ({ ...e, isFiltered: true, sortOrder: 'asc' }))
